import Row from "./Row";
import { useSelector } from "react-redux";
import { selectMetadata } from "../redux/reportSlice";

function Grid(props) {
  const metadata = useSelector(selectMetadata);
  const data = props.data;
  return (
    <table
      className="table table-sm table-stripped table-bordered grid-report-format"
      data-testid="grid"
    >
      <thead>
        <tr>
          {metadata.columns.map((c, idx) => {
            return (
              <th key={`th-${idx}`} className={c.className}>
                {c.name}
              </th>
            );
          })}
        </tr>
      </thead>
      <tbody>
        {data !== null &&
          data.map((d, idx) => {
            return (
              <Row
                key={`grid-${idx}`}
                metadata={metadata}
                index={idx}
                data={d}
              />
            );
          })}
      </tbody>
    </table>
  );
}

export default Grid;
